import superagent from 'superagent';
// import webservice from './webservice';
import getCookie from './getCookie';

export default async function getBranchSolicitar({ jsonBody, type }) {
  const wsToUse = (type === 'inactive' && 'getBranchSolicitar2') || 'getBranchSolicitar';
  const url = `${process.env.REACT_APP_ADMI_WEBSERVICE}/${wsToUse}`;

  let response = {};

  await superagent
    .get(url)
    .query(jsonBody)
    .set('Content-Type', 'application/json')
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .then((res) => {
      response = res.body;
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        ...jsonBody,
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      response = resp;
    });

  return response;
}
